<div class="uk-card uk-card-default uk-width-1-1@xl border-radius-5">
  <h3 class="uk-card-title uk-background-muted k-text-uppercase uk-padding-small k-card-title">
    Apprenant(s)
  </h3>
  <kendo-grid [data]="listApprenant | async">
    <kendo-grid-column class="k-text-uppercase" field="apprenant_statut" title="STATUT" [width]="60"> </kendo-grid-column>
    <kendo-grid-column field="civilite" title="CIVILITÉ" [width]="60"> </kendo-grid-column>
    <kendo-grid-column field="nom" title="NOM" [width]="60"> </kendo-grid-column>
    <kendo-grid-column field="prenom" title="PRÉNOM" [width]="60"> </kendo-grid-column>
    <kendo-grid-column field="date_naissance" title="DATE DE NAISSANCE" [width]="60">
      <ng-template kendoGridCellTemplate let-listApprenant>
        {{ listApprenant.date_naissance | date: 'dd/MM/yyyy' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="matricule" title="MATRICULE" [width]="60"> </kendo-grid-column>
    <kendo-grid-column field="nom_client" title="CLIENT" [width]="140"> </kendo-grid-column>
  </kendo-grid>
</div>
